// Constants around the authentication process

export const LOGIN_ROUTE = '/login';
export const CALLBACK_ROUTE = '/login-callback';
export const ROOT_ROUTE = '/';
